import React from 'react';
import RoleSuccessPage from '../RoleManagement/RoleSuccessPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './SubDistributorSuccessPage.module.css';
import qrCode from '../../assets/images/qr-admin.png';

const SubDistributorSuccessPage: React.FC = () => (
  <RoleSuccessPage config={ROLE_CONFIGS.subDistributor} styles={styles} staticQrImage={qrCode} />
);

export default SubDistributorSuccessPage;
